import { Game } from "./game"

interface Glider {
  id: number
  name: string
  icon: string
}

export const gliderMap: Record<Game, Glider[]> = {
  [Game.MK8]: [
    { id: 0, name: "Super Glider", icon: "super_glider" },
    { id: 1, name: "Cloud Glider", icon: "cloud_glider" },
    { id: 2, name: "Wario Wing", icon: "wario_wing" },
    { id: 3, name: "Waddle Wing", icon: "waddle_wing" },
    { id: 4, name: "Peach Parasol", icon: "peach_parasol" },
    { id: 5, name: "Parachute", icon: "parachute" },
    { id: 6, name: "Parafoil", icon: "parafoil" },
    { id: 7, name: "Flower Glider", icon: "flower_glider" },
    { id: 8, name: "Bowser Kite", icon: "bowser_kite" },
    { id: 9, name: "Plane Glider", icon: "plane_glider" },
    { id: 10, name: "MKTV Parafoil", icon: "mktv_parafoil" },
    { id: 11, name: "Gold Glider", icon: "gold_glider" },
    { id: 12, name: "Hylian Kite", icon: "hylian_kite" },
    { id: 13, name: "Paper Glider", icon: "paper_glider" },
  ],
  [Game.MK8DX]: [
    { id: 0, name: "Super Glider", icon: "super_glider" },
    { id: 1, name: "Cloud Glider", icon: "cloud_glider" },
    { id: 2, name: "Wario Wing", icon: "wario_wing" },
    { id: 3, name: "Waddle Wing", icon: "waddle_wing" },
    { id: 4, name: "Peach Parasol", icon: "peach_parasol" },
    { id: 5, name: "Parachute", icon: "parachute" },
    { id: 6, name: "Parafoil", icon: "parafoil" },
    { id: 7, name: "Flower Glider", icon: "flower_glider" },
    { id: 8, name: "Bowser Kite", icon: "bowser_kite" },
    { id: 9, name: "Plane Glider", icon: "plane_glider" },
    { id: 10, name: "MKTV Parafoil", icon: "mktv_parafoil" },
    { id: 11, name: "Gold Glider", icon: "gold_glider" },
    { id: 12, name: "Hylian Kite", icon: "hylian_kite" },
    { id: 13, name: "Paper Glider", icon: "paper_glider" },
    { id: 14, name: "Paraglider", icon: "paraglider" },
  ],
}